export default __webpack_public_path__ + "static/media/edunext.2f63fc93.png";